/** @jsx builderX.jsx */
import { builderX, Sprite } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='newReels'>
    <Sprite position={[492, 312]} name='reel0'>
        <Sprite name='3x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 480]} name='sym1'/>
            <Sprite position={[0, 960]} name='sym2'/>
        </Sprite>
        <Sprite position={[0, 480]} name='4x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 360]} name='sym1'/>
            <Sprite position={[0, 720]} name='sym2'/>
            <Sprite position={[0, 1080]} name='sym3'/>
        </Sprite>
        <Sprite position={[0, 960]} name='5x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 288]} name='sym1'/>
            <Sprite position={[0, 576]} name='sym2'/>
            <Sprite position={[0, 864]} name='sym3'/>
            <Sprite position={[0, 1152]} name='sym4'/>
        </Sprite>
    </Sprite>
    <Sprite position={[1068, 312]} name='reel1'>
        <Sprite name='3x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 480]} name='sym1'/>
            <Sprite position={[0, 960]} name='sym2'/>
        </Sprite>
        <Sprite position={[0, 480]} name='4x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 360]} name='sym1'/>
            <Sprite position={[0, 720]} name='sym2'/>
            <Sprite position={[0, 1080]} name='sym3'/>
        </Sprite>
        <Sprite position={[0, 960]} name='5x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 288]} name='sym1'/>
            <Sprite position={[0, 576]} name='sym2'/>
            <Sprite position={[0, 864]} name='sym3'/>
            <Sprite position={[0, 1152]} name='sym4'/>
        </Sprite>
    </Sprite>
    <Sprite position={[1644, 312]} name='reel2'>
        <Sprite name='3x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 480]} name='sym1'/>
            <Sprite position={[0, 960]} name='sym2'/>
        </Sprite>
        <Sprite position={[0, 480]} name='4x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 360]} name='sym1'/>
            <Sprite position={[0, 720]} name='sym2'/>
            <Sprite position={[0, 1080]} name='sym3'/>
        </Sprite>
        <Sprite position={[0, 960]} name='5x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 288]} name='sym1'/>
            <Sprite position={[0, 576]} name='sym2'/>
            <Sprite position={[0, 864]} name='sym3'/>
            <Sprite position={[0, 1152]} name='sym4'/>
        </Sprite>
    </Sprite>
    <Sprite position={[2220, 312]} name='reel3'>
        <Sprite name='3x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 480]} name='sym1'/>
            <Sprite position={[0, 960]} name='sym2'/>
        </Sprite>
        <Sprite position={[0, 480]} name='4x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 360]} name='sym1'/>
            <Sprite position={[0, 720]} name='sym2'/>
            <Sprite position={[0, 1080]} name='sym3'/>
        </Sprite>
        <Sprite position={[0, 960]} name='5x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 288]} name='sym1'/>
            <Sprite position={[0, 576]} name='sym2'/>
            <Sprite position={[0, 864]} name='sym3'/>
            <Sprite position={[0, 1152]} name='sym4'/>
        </Sprite>
    </Sprite>
    <Sprite position={[2796, 312]} name='reel4'>
        <Sprite name='3x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 480]} name='sym1'/>
            <Sprite position={[0, 960]} name='sym2'/>
        </Sprite>
        <Sprite position={[0, 480]} name='4x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 360]} name='sym1'/>
            <Sprite position={[0, 720]} name='sym2'/>
            <Sprite position={[0, 1080]} name='sym3'/>
        </Sprite>
        <Sprite position={[0, 960]} name='5x5'>
            <Sprite name='sym0'/>
            <Sprite position={[0, 288]} name='sym1'/>
            <Sprite position={[0, 576]} name='sym2'/>
            <Sprite position={[0, 864]} name='sym3'/>
            <Sprite position={[0, 1152]} name='sym4'/>
        </Sprite>
    </Sprite>
    <Sprite name='extraReel'/>
</Sprite>;
